import { CartData } from 'store/addToCart/types';
import { Variant, PrimaryCategories, Product } from 'store/product/types';
import {
  PageLocationType,
  ListingProduct,
} from 'shared/store/categoryListing/types';
import { AddToCartParams } from 'store/addToCart/action';
import { User } from 'store/auth/types';
import { PageJourney } from 'store/dataLayer/action';
import { Device } from 'types';

export interface ActionsProps {
  product: Variant | ListingProduct;
  productData: ListingProduct;
  parentId: string;
  enableAnimation?: boolean;
  handleAddToCartTracking: (cartData: CartData, productData?: any) => void;
  primaryCategories: PrimaryCategories;
  pageType?: string;
  pageLocation: PageLocationType;
  lang?: string;
  clickedFrom?: string;
  videoId?: string;
  ctaText?: string;
  onErrorAddToBag: () => void;
  handleInteraction?: () => void;
  newButtonText?: string;
  isDefaultSelected?: boolean;
  preloadTillRecommendations: () => void;
  multiCouponsEnabled: boolean;
  newCtaText?: string;
  setNewCtaText?: (prop: string) => void;
  isGoToBag?: boolean;
  setIsGoToBag?: (prop: boolean) => void;
  setBuyNowClicked?: (prop: boolean) => void;
}

export interface WishlistActionProps {
  dispatch: any;
  setIsInWishlist: (prop: boolean) => void;
  setWishlistMessage: (prop: string) => void;
  setWishlistError: (prop: boolean) => void;
  pageLocation?: PageLocationType | undefined;
  primaryCategories?: PrimaryCategories;
  brandName: string | undefined;
  videoId?: string;
  product: Variant | ListingProduct;
  productData: ListingProduct;
  user?: User;
  pwPageSource?: string;
  trackingData?: string;
  gptConversationId?: string;
  isConvSearch?: boolean;
  appTrackingKeys?: Record<string, any>;
  interactionInfo?: any;
  device: Device;
}

export interface AddToCartActionProps {
  productPage: Product;
  onErrorAddToBag: () => void;
  isLoading: boolean;
  setIsLoading: (prop: boolean) => void;
  product: Variant | ListingProduct;
  user: User;
  doAddToCart: (
    props: AddToCartParams,
    convenienceChargesEnabled?: boolean
  ) => void;
  dispatch: any;
  handleAddToCartTracking: (
    cartData: CartData,
    product: Variant | ListingProduct,
    addToCartTrackingData?: Record<string, any>
  ) => void;
  ctaText: string;
  setAddToBagError: (prop: boolean) => void;
  setAddToBagMessage: (prop: string) => void;
  lang?: string;
  isExperimentEnabled: boolean;
  clickedFrom?: string;
  ITEM_ADDED_TO_CART: string;
  setCouponPopupHeader?: (prop: string) => void;
  setCouponsAppliedList?: (prop: string) => void;
  isDefaultSelected?: boolean;
  isFirstFoldExp?: boolean;
  isGoToBag?: boolean;
  setIsGoToBag?: (prop: boolean) => void;
  setNewCtaText?: (prop: string) => void;
  preloadTillRecommendations?: () => void;
  multiCouponsEnabled: boolean;
  trackAddToCartData?: Record<string, any>;
  isPdpCtaExpEnabled: boolean;
  journeyData: PageJourney;
  isHlpCtaExpEnabled: boolean;
  gptConversationId?: string;
  isConvSearch?: boolean;
  handlePostAddToCart?: (increaseCount: number) => void;
  onStepperCountChanged?: (productId: string, updatedCount: number) => void;
  appTrackingKeys?: Record<string, any>;
  plpInteractionData?: Record<string, any>;
  setDealDeltaText?: (prop: string) => void;
  isConvenienceFeeEnabled?: boolean;
  readUrlParamsForTracking?: boolean;
}

export enum PAGE_TYPES {
  ImageFullScreen = 'ImageFullScreen',
  VideoFullScreen = 'VideoFullScreen',
  All_Reviews_Page = 'All Reviews Page',
  all_shade = 'all_shade',
  SIZE_CHART = 'size-chart',
}

export interface BuyNowActionProps {
  productPage: Product;
  onErrorAddToBag: () => void;
  product: Variant | ListingProduct;
  user: User;
  doAddToCartAndRefresh: (
    props: AddToCartParams,
    convenienceChargesEnabled?: boolean,
    buyNow?: boolean
  ) => void;
  dispatch: any;
  setAddToBagError: (prop: boolean) => void;
  setAddToBagMessage: (prop: string) => void;
  isDefaultSelected?: boolean;
  journeyData?: PageJourney;
  isConvenienceFeeEnabled?: boolean;
  buyNowLoading: boolean;
  setBuyNowLoading: (prop: boolean) => void;
  showBuyNow?: boolean;
  isLoggedIn?: boolean;
}
export interface UpdatedTrackingKeys {
  updatedSiteNav: string;
  updatedSiteSubNav: string;
}

export interface BuyNowCtaClickedData {
  brandName: string;
  categoryL1Name: string;
  categoryL2Name: string;
  categoryL3Name: string;
  discountedPrice: number | string;
  isLoggedIn: boolean;
  productId: string | number;
  productName: string;
  products: unknown;
  variantProductId: string | number;
  variantType: string;
}
